import '@babel/polyfill';
import { render } from 'react-dom';
import '@saucelabs/sl-style-main';
import '@saucelabs/sl-util-sentry';
import config from '@saucelabs/sl-util-config';

import router from './router';


config.load(window.WEB_SETTINGS);
render(router, document.getElementById('app'));

/*
  NOTE: should be last to don't block more important requests
  FIXME: use async load technique + localStorage:
         https://www.sitepoint.com/improving-font-performance-subsetting-local-storage/
*/
import '@saucelabs/sl-style-font/lib/fonts.css'; // eslint-disable-line
